import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Table, Button, Badge, Form, Container } from 'react-bootstrap';

import WhatsAppAPI from '../../api/WhatsAppAPI';
import {
    DatatableWrapper,
    Filter,
    Pagination,
    PaginationOptions,
    TableBody,
    TableHeader,
  } from "react-bs-datatable";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ShimmerTable } from "react-shimmer-effects";

const Wallet = () => {
  const [wallet, setWallet] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [show, setShow] = useState(false);
  const [amount, setAmount] = useState('');
  const [tenantcode, setTenantcode] = useState('');
  const [reason, setReason] = useState('');
  const [txStatus, setTxStatus] = useState('paid');
  const [txType, setTxType] = useState('credit');
  const [isSpinner, setIsSpinner] = useState(false);
  const [availableSchemas, setAvailableSchemas] = useState([]);

  useEffect(() => {
    fetchWallet();
    fetchTransactions();
    fetchSchemas();
  }, []);

   const fetchSchemas = async () => {
    const result = await WhatsAppAPI.fetchSourceSchemas();
    if (result.sourceSchemaResult) {
      setAvailableSchemas(result.sourceSchemaResult);
    } else {
      toast.error("Failed to fetch schemas.");
    }
  };

  const fetchWallet = async () => {
    const res = await WhatsAppAPI.getWalletBalance(null);
    if(res.success){
      setWallet(res.data);
    }else{
      setWallet([]);
    }
    setIsSpinner(true);
  };

  const fetchTransactions = async () => {
    const res = await WhatsAppAPI.getWalletTransactions();
    if(res.success){
      setTransactions(res.data);
    }else{
      setTransactions([]);
    }
    setIsSpinner(true);
  };

  const handleRecharge = async () => {
    const res = await WhatsAppAPI.createWalletTransaction({ amount, reason, type: 'credit', status: 'paid', tenantcode: tenantcode });
    if(res.success){
      toast.success(res.message);
      setShow(false);
     setAmount('');
     setTenantcode('');
      setReason('');
      fetchWallet();
      fetchTransactions();
    }else{
      toast.error(res.message);
    }
  };


  
  const header = [
    {
      title: "Date",
      prop: "createddate",
      isFilterable: true,
      cell: (row) => (
        <span
          style={{ cursor: "pointer", color: "#007bff" }}
        >
          {row.createddate ? new Date(row.createddate).toLocaleString() : "-"}
        </span>
      ),
    },
    {
      title: "Type",
      prop: "type",
      cell: (row) => {
        if (!row.type) {
          return <span className="text-muted">-</span>;
        }
        return (
          <div style={{ maxWidth: "200px" }}>
            <small>
              <span className="fw-semibold">{row.type === 'credit' ? 'Credit' : 'Debit'}</span>
            </small>
          </div>
        );
      
      },
    },
    {
      title: "Amount",
      prop: "amount",
      isFilterable: true,
      cell: (row) => (
        <span>
          {row.amount}
        </span>
      ),
    },
    {
      title: "Reason",
      prop: "reason",
      isFilterable: true,
      cell: (row) => (
        <span>
          {row.reason}
        </span>
      ),
    },
    {
      title: "Balance After",
      prop: "balance_after",
      isFilterable: true,
      cell: (row) => (
        <span>
          {row.balance_after}
        </span>
      ),
    },
    
  ];

  const labels = {
    beforeSelect: " ",
  };

  
  const handleStatusToggle = async (row) => {
    try {
      const updatedTransaction = { ...row, status: row.status === 'paid' ? 'unpaid' : 'paid' };
      const response = await WhatsAppAPI.updateTransaction(row.id, updatedTransaction);
      if (response.success) {
        toast.success("Transaction status updated successfully");
        fetchTransactions();
      } else {
        toast.error("Failed to update transaction status");
      }
    } catch (error) {
      toast.error("Error updating transaction status");
    }
  };


  return (
    <>
   <Container className="mt-5 mb-5">
      {/* Top summary boxes */}
      <Row className="mx-5 mb-4">
        <Col lg={3} md={6} className="mb-3">
          <Card className="p-3 bg-white shadow-sm border-0 rounded-3 text-center">
            <Card.Title className="fw-semibold mb-1">Available Credits</Card.Title>
            <h3 className="fw-bold text-success">{wallet.available_credits}</h3>
          </Card>
        </Col>
        <Col lg={3} md={6} className="mb-3">
          <Card className="p-3 bg-white shadow-sm border-0 rounded-3 text-center">
            <Card.Title className="fw-semibold mb-1">Total Credited</Card.Title>
            <h3 className="fw-bold text-primary">{wallet.total_credited}</h3>
          </Card>
        </Col>
        <Col lg={3} md={6} className="mb-3">
          <Card className="p-3 bg-white shadow-sm border-0 rounded-3 text-center">
            <Card.Title className="fw-semibold mb-1">Total Debited</Card.Title>
            <h3 className="fw-bold text-danger">{wallet.total_debited}</h3>
          </Card>
        </Col>
        <Col lg={3} md={6} className="mb-3">
          <Card className="p-3 bg-white shadow-sm border-0 rounded-3 text-center">
            <Card.Title className="fw-semibold mb-1">Last Recharged On</Card.Title>
            <h6 className="fw-bold">{wallet.last_recharged_on ? new Date(wallet.last_recharged_on).toLocaleString() : "-"}</h6>
          </Card>
        </Col>
      </Row>

      {/* Main content: Table and Form side by side */}
      <Row className="mx-5 g-4">
        <Col lg={8} className="mb-3">
          <div className="bg-white shadow-sm border-0 rounded-3 p-4">
            <h5 className="fw-semibold mb-3">💳 Wallet Transactions</h5>
            {isSpinner ? (
              <DatatableWrapper
                body={transactions}
                headers={header}
                paginationOptionsProps={{
                  initialState: {
                    rowsPerPage: 10,
                    options: [5, 10, 15, 20],
                  },
                }}
              >
                <Row className="mb-3">
                  <Col lg={4} className="d-flex justify-content-end align-items-end">
                    <Filter className="p-2" />
                  </Col>
                  <Col lg={4} className="d-flex justify-content-start align-items-start">
                    <PaginationOptions labels={labels} />
                  </Col>
                </Row>
                <div className="table-responsive">
                  <Table striped bordered className="related-list-table" responsive="sm">
                    <TableHeader />
                    <TableBody />
                  </Table>
                </div>
                <Pagination />
              </DatatableWrapper>
            ) : (
              <ShimmerTable
                columns={header.length}
                rows={10}
                rowHeight={30}
                rowGap={10}
                columnGap={10}
              />
            )}
          </div>
        </Col>
        <Col lg={4} className="mb-3">
          <div className="bg-white shadow-sm border-0 rounded-3 p-4">
            <h5 className="fw-semibold mb-3">➕ Add Transaction</h5>
            <Form>
               <Form.Group className="mb-3">
                  <Form.Label>Source Schema</Form.Label>
                  <Form.Control
                    style={{ height: "36px" }}
                    as="select"
                    name="source_schemaname"
                    value={tenantcode}
                    onChange={e => setTenantcode(e.target.value)}
                    required
                  >
                    <option value="">Select Schema</option>
                    {availableSchemas.map((schema) => (
                      <option key={schema} value={schema}>
                        {schema}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Amount</Form.Label>
                <Form.Control
                  style={{ height: "36px" }}
                  type="number"
                  value={amount}
                  onChange={e => setAmount(e.target.value)}
                  placeholder="Enter amount"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Reason</Form.Label>
                <Form.Control
                  style={{ height: "36px" }}
                  type="text"
                  value={reason}
                  onChange={e => setReason(e.target.value)}
                  placeholder="Enter reason"
                />
              </Form.Group>
              <Button variant="primary" className="w-100" onClick={handleRecharge}>
                Add Transaction
              </Button>
            </Form>
          </div>
        </Col>
      </Row>
      <ToastContainer />
    </Container>
  </>

  );
};

export default Wallet;